<p-tabView *ngIf="mail_id && !resendMail">
  <p-tabPanel header="Detalle">
    <div class="">
      <div>
        <div class="col-lg-12 animated fadeInRight">
          <div class="mail-box-header">
            <div class="mail-tools tooltip-demo m-t-md">
              <h3>
                <span class="title">Asunto: </span>{{email.subject}}
              </h3>
              <span class="title">Desde: </span>{{email.from}}
              <div style="float: right; font-size: 13px;">{{ email.date | date: 'dd/MM/yyyy hh:mm'}}</div>

            </div>
          </div>
          <div class="mail-box">
            <div class="mail-body">
              <p [innerHTML]="email.body"></p>
              <!--<p [innerHTML]="sanitizer.bypassSecurityTrustHtml(email.body)"></p>-->
            </div>
            <div class="mail-attachment">
              <p>
                <span>
                  <i class="fa fa-paperclip"></i> {{email.files.length}} Adjuntos
                </span>
              </p>
              <div class="attachments">
                <div class="file-box" *ngFor="let file of email.files; let i = index">
                  <div class='file'>
                    <a href='{{getUrl(file.guid)}}' target="_blank">
                      <span class="corner"></span>
                      <div class='icon'>
                        <img alt='image' class='img-fluid' src='{{getUrlIcon(file.mimetype)}}' width='40'>
                      </div>
                      <div class='file-name text-align-center'>
                        <div class='titleEllipsis' style=' font-size: 12px; '>
                          <strong>{{file.filename}}</strong>
                        </div>
                      </div>
                    </a>
                  </div>
                </div>
                <div class="clearfix"></div>
              </div>
            </div>
            <div class="clearfix"></div>
          </div>
        </div>
      </div>


    </div>
  </p-tabPanel>

  <p-tabPanel *ngIf="mail_id && !resendMail && email.type != 'in'">
    <ng-template pTemplate="header">
      <span class="p-tabview-title ng-star-inserted">
        Destinatarios
        <div *ngIf="email.type!='in'" class="p-ml-2 badge badge-block {{(countSentsMessages == total_tos ? 'badge-success' : 'badge-danger')}}">{{countSentsMessages}}/{{total_tos}}</div>
      </span>
    </ng-template>

    <div class="p-grid">
      <div class="p-col-6 p-field">
        <label for="status">Estado</label>
        <p-dropdown name="state" [options]="statusOptions" [(ngModel)]="notificationsToFilters.state"
          (onChange)="onStateChange($event)" optionLabel="state" optionValue="value" [showClear]="true"
          placeholder="Selecciona un estado">
        </p-dropdown>
      </div>
      <div class="p-col-6 p-field">
        <label for="mails">Email</label>
        <input name="mails" type="text" pInputText [(ngModel)]="notificationsToFilters.email" (keyup)="search()" />
      </div>
    </div>

    <p-table #grid [value]="notificationsTo">
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="state" width="140">Estado</th>
          <th pSortableColumn="mails">Correo electrónico</th>
          <th pSortableColumn="times_open">Nº veces abierto</th>
          <th pSortableColumn="last_time_opened">Última fecha</th>
          <th width="70"></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-notificationTo>
        <tr (dblclick)="viewInfo(notificationTo)">
          <td [innerHTML]="getState(notificationTo.state)" width="140"></td>
          <td>{{notificationTo.recipient_type == 'to'?'Para':notificationTo?.recipient_type?.toUpperCase()}}:
            {{notificationTo.mails}}</td>
          <td>{{notificationTo.times_open?notificationTo.times_open:"0"}}</td>
          <td>{{notificationTo.last_time_opened | date: 'dd/MM/yyyy HH:mm:ss'}} {{notificationTo.last_time_opened
            ? '' : 'Sin abrir'}}
          </td>
          <td class="grid-actions">
            <!--a (click)="resendMail(notificationsTo)">
              <fa-icon [icon]="['fas', 'share']"></fa-icon>
            </a-->
            <a (click)="viewInfo(notificationTo)">
              <fa-icon [icon]="['fas', 'info-circle']"></fa-icon>
            </a>
            <!--<a (click)="delete(configurationType)" class="color-danger"><fa-icon [icon]="['far', 'trash-alt']"></fa-icon></a>-->
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="5">
            No se encontraron datos
          </td>
        </tr>
      </ng-template>
    </p-table>

  </p-tabPanel>

  <p-tabPanel header="Asignación" *ngIf="mail_id && !resendMail && email.type == 'in' && email.status != 'received'">

    <p-table #grid [value]="notificationsTo">
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="mails">Correo electrónico</th>
          <th pSortableColumn="organization">Empresa</th>
          <th pSortableColumn="contact">Contacto</th>
          <!--<th pSortableColumn="state">Estado</th>-->
          <th width="150"></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-notificationTo>
        <tr (dblclick)="viewInfo(notificationTo)" *ngIf="notificationTo.state != 'discarded'">
          <td>
            {{notificationTo.mails}}
          </td>

          <td class="p-field">
            <p-dropdown name="organization_id" [(ngModel)]="notificationTo.organization_id" [filter]="true" filterBy="name"
                        [options]="organizations" placeholder="Selecciona organización" optionLabel="name" optionValue="id"
                        [showClear]="true" appendTo="body" (onChange)="onChangeOrganization(notificationTo)" (onFilter)="onOrganizationFilter($event)"></p-dropdown>
          </td>
          <td class="p-field">
            <p-dropdown name="contact_id" [(ngModel)]="notificationTo.contact_id" [filter]="true" filterBy="fullname"
                        [options]="contacts[notificationTo.id]" optionLabel="fullname" placeholder="Selecciona contacto"
                        optionValue="id" [showClear]="true" appendTo="body" [disabled]="!notificationTo.organization_id"
                        (onChange)="onChangeContact(notificationTo)">
              <ng-template let-item pTemplate="item">
                {{item.fullname}}<br />
                <small>{{item.email}}</small>
              </ng-template>
            </p-dropdown>
          </td>

          <!--<td>
          <div class='badge badge-block badge-success' *ngIf="notificationTo.state == 'assigned'">Asignado</div>
          <div class='badge badge-block badge-warning' *ngIf="notificationTo.state == 'pending_assign'">
            Pendiente de asignar</div>
          <div class='badge badge-block badge-danger' *ngIf="notificationTo.state == 'discarded'">Descartado
          </div>
        </td>-->

          <td class="grid-actions">
            <p-button (click)="discardNotificationTo(notificationTo)" styleClass="p-button-danger">
              <fa-icon [icon]="['fas', 'times']"></fa-icon>&nbsp;Descartar
            </p-button>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="2">
            No se encontraron datos
          </td>
        </tr>
      </ng-template>
    </p-table>
    <div class="p-mt-4 p-d-flex p-jc-end">
      <button pButton (click)="assign()" icon="pi pi-check" label="Procesar asignación"
              [disabled]="!allNotificationsAssigned"></button>
    </div>
  </p-tabPanel>
</p-tabView>

<div *ngIf="!mail_id || resendMail">
  <div class="p-col-12" id="mailDetail">
    <div class="p-card">
      <div class="p-grid p-col-12">
        <div class="p-col-12 p-field" *ngIf="!mail_id && templates.length > 0">
          <label for="template">Plantilla</label>
          <p-dropdown name="template" [(ngModel)]="email.template_id" [options]="templates" optionLabel="name"
            (onChange)="loadTemplateValue($event)" optionValue="id" [showClear]="true" appendTo="body"
            [disabled]="disableFields">
          </p-dropdown>
        </div>
        <div class="p-col-12 p-field">
          <label for="from">
            Desde
            <a (click)="openEditUser()" style="float: right">Configurar cuentas de correo</a>
          </label>
          <p-dropdown name="from" [(ngModel)]="email.from" [options]="emails" optionValue="mailAccount.name" [filter]="true" filterBy="mailAccount.name"
            required="true" optionLabel="mailAccount.name" placeholder="Selecciona email"
            [disabled]="disableFields"></p-dropdown>
        </div>
        <div class="p-col-12 p-field p-fluid">
          <label for="to">
            Para

            <a (click)="changeCCCblock()" *ngIf="!showCCCblock" style="float: right">Mostrar CCC</a>
            <a (click)="changeCCCblock()" *ngIf="showCCCblock" style="float: right">Ocultar CCC</a>
            <a (click)="openUsersSearcher('to')" style="float: right; margin-right: 10px;">Buscar</a>
          </label>
          <p-autoComplete [(ngModel)]="email.to" [suggestions]="searchResults" class="topAutoComplete"
            (completeMethod)="filterSearch($event)" field="email" [multiple]="true"
            [disabled]="disableFields"></p-autoComplete>
        </div>
        <div class="p-col-12 p-field p-fluid" *ngIf="showCCCblock">
          <label for="ccc">CCC
            <a (click)="openUsersSearcher('ccc')" style="float: right; margin-right: 10px;">Buscar</a>
          </label>
          <p-autoComplete [(ngModel)]="email.ccc" [suggestions]="searchResults" class="topAutoComplete"
            (completeMethod)="filterSearch($event)" field="email" [multiple]="true"
            [disabled]="disableFields"></p-autoComplete>
        </div>
        <div class="p-col-12 p-field p-fluid" *ngIf="showCCCblock">
          <label for="bcc">BCC
            <a (click)="openUsersSearcher('bcc')" style="float: right; margin-right: 10px;">Buscar</a>
          </label>
          <p-autoComplete [(ngModel)]="email.bcc" [suggestions]="searchResults" class="topAutoComplete"
            (completeMethod)="filterSearch($event)" field="email" [multiple]="true" [disabled]="disableFields">
          </p-autoComplete>
        </div>
        <div class="p-col-12 p-field">
          <label for="subject">Asunto</label>
          <input name="subject" pInputText type="text" [(ngModel)]="email.subject" [disabled]="disableFields">
        </div>
        <div class="p-col-12 p-field">
          <label for="message">Mensaje</label>
          <editor name="message" [(ngModel)]="email.body" apiKey="dve1lwso187it38lpq8gfhgoupl6h8kxe0zwpymefrnkyhdl"
            [init]="{
                                height: 500,
                                menubar: true,
                                toolbar:[
                                    'undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist checklist | forecolor backcolor casechange permanentpen formatpainter removeformat | pagebreak | charmap emoticons | fullscreen  preview save print | insertfile image media pageembed template link anchor codesample | a11ycheck ltr rtl | showcomments addcomment'
                                ],
                                toolbar_mode: 'wrap',
                                language: 'es'}" [disabled]="disableFields" plugins="link media image fullscreen code"></editor>
        </div>
        <div class="p-col-12 p-field" style="position:relative">
          <label for="myfile[]">Adjuntos</label>
          <!--<p-fileUpload name="myfile[]" url="/api/attachments/upload" (onError)="onErrorUpload($event)"
              (onUpload)="onBasicUpload($event)" multiple="multiple" [showUploadButton]="false" [auto]="true" chooseLabel="Subir adjuntos mail">
          </p-fileUpload>-->
          <p-fileUpload name="myfile[]" [showUploadButton]="false" url="/api/attachments/upload"
            (onError)="onErrorUpload($event)" (onUpload)="onBasicUpload($event)" multiple="multiple"
            [showUploadButton]="false" [auto]="true" chooseLabel="Subir adjuntos" [disabled]="disableFields">
            <ng-template pTemplate="content">
              <!--<ul *ngIf="email.files.length">
                <li *ngFor="let file of email.files; let i = index">
                  <a (click)="deleteAttachment(file.guid, i)">
                    <i class="pi pi-times-circle "
                       style="font-size: 12px;margin-right: 10px;"
                       *ngIf="!disableFields"></i>
                  </a>
                  {{file.description ? file.description:file.filename}} - {{file.size}} bytes
                </li>
              </ul>-->
              <div class="p-grid" *ngIf="email.files.length">
                <div class="p-col-3 p-p-4" *ngFor="let file of email.files; let i = index">

                  <p-card>
                    <a (click)="deleteAttachment(file.guid, i)">
                      <i class="pi pi-times-circle "
                        style="font-size: 12px;margin-right: 10px;position: absolute; right: 0px; top: 5px;"
                        *ngIf="!disableFields"></i>
                    </a>
                    <div style="display: flex; align-items: center; padding-top: 15px;">
                      <img alt="Card" src="/assets/img/mimes/{{getImage(file.mimetype)}}" width="40"
                        style="width: 40px; margin-right: 10px">
                      <div style="font-size: 12px">
                        <span>{{file.filename}} - {{file.size}} bytes</span><br />
                        <span>Nº veces descargado: {{file.times_open?file.times_open:'0'}}</span>
                      </div>
                    </div>

                  </p-card>
                  <!--
  <p-card subheader="{{file.description ? file.description:file.filename}}"
          [style]="{width: '100%'}" styleClass="p-card-shadow">
    <ng-template pTemplate="header">
      <div style="text-align: center;">
        <img alt="Card" src="/assets/img/mimes/{{getImage(file.mimetype)}}" width="40" style="width: 40px;" >
      </div>
    </ng-template>
    <p>{{file.filename}} - {{file.size}} bytes</p>
    <p>Nº veces descargado: {{file.times_open?file.times_open:'0'}}</p>
  </p-card>-->
                </div>
              </div>
            </ng-template>
          </p-fileUpload>
          <p-button label="Seleccionar de Axial" icon="pi pi-plus" (click)="uploadAxial()" class="buttonSelectFromAxial"
            [disabled]="disableFields"></p-button>
        </div>
        <div class="p-col-12 p-field" style="position:relative" *ngIf="errorText != null && errorText.length > 0">
          <label for="errorText">Error</label>
          <textarea pInputTextarea name="errorText" id="errorText" autoResize="autoResize"
            disabled>{{errorText}}</textarea>
        </div>
        <!--div class="p-col-12 p-field">
            <p-fileUpload name="myfile[]" url="./api/attachments/upload.php" (onError)="onErrorUpload($event)"
                multiple="multiple" [showUploadButton]="false">
                <ng-template pTemplate="toolbar">
                    <div>Upload 3 Files</div>
                </ng-template>
                <ng-template let-file pTemplate="file">
                    <div>Nombre: {{file.name}}</div>
                </ng-template>
                <ng-template pTemplate="content" let-files>
                    <div>Additional content.</div>
                </ng-template>
            </p-fileUpload>
        </div>-->
      </div>
    </div>
  </div>
  <div class="p-col-12">
    <button pButton style="float: right;" (click)="sendEmail()"
      [disabled]="disableFields && !resendMail">Enviar</button>
  </div>
</div>
